import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query'

import * as dealsAPI from '../../../apis/dealsAPI'
import type { ShipmentEntity, UpdateShipmentReqBody } from '../../../apis/dealsAPI'
import { useApiErrorHandler } from '../../../hooks/useApiErrorHandler'

import { DEALS_QUERY_KEY_ROOT } from './useDealsQuery'
import { dealQueryKey } from './useDealQuery'
import { shipmentsQueryKey } from './useShipmentsQuery'

interface UpdateVariables {
  dealId: string
  shipmentId: string
  body: UpdateShipmentReqBody
}

export function useUpdateShipmentMutation(): UseMutationResult<ShipmentEntity, unknown, UpdateVariables> {
  const queryClient = useQueryClient()
  const handleError = useApiErrorHandler()

  return useMutation<ShipmentEntity, unknown, UpdateVariables>(
    ({ dealId, shipmentId, body }) => dealsAPI.updateShipment(dealId, shipmentId, body),
    {
      onSuccess: (_shipment, { dealId }) => {
        queryClient.invalidateQueries({ queryKey: DEALS_QUERY_KEY_ROOT })
        queryClient.invalidateQueries({ queryKey: shipmentsQueryKey(dealId) })
        queryClient.invalidateQueries({ queryKey: dealQueryKey(dealId) })
      },
      onError: handleError,
    },
  )
}
